const nf = new Intl.NumberFormat('cs-CZ');

export const CZK_PER_EUR = 24.35;

export function czkFirst(slug: string | null | undefined): boolean {
  return slug === 'affilmaster';
}

export function money(eurValue: number, slug: string | null | undefined): string {
  return czkFirst(slug)
    ? `${nf.format(Math.round(eurValue * CZK_PER_EUR))} Kč`
    : `${nf.format(Math.round(eurValue))} €`;
}

export function moneyAlt(eurValue: number, slug: string | null | undefined): string | null {
  return czkFirst(slug) ? `${nf.format(Math.round(eurValue))} €` : null;
}

export function moneyUnit(slug: string | null | undefined): string {
  return czkFirst(slug) ? 'Kč' : '€';
}

export function draftFromEur(eurValue: number | null | undefined, slug: string | null | undefined): string {
  if (eurValue == null) return '';
  return String(czkFirst(slug) ? Math.round(eurValue * CZK_PER_EUR) : eurValue);
}

export function eurFromDraft(value: number, slug: string | null | undefined): number {
  const eurValue = czkFirst(slug) ? value / CZK_PER_EUR : value;
  return Math.round(eurValue * 100) / 100;
}
